export default __webpack_public_path__ + "static/media/hedera-hashgraph-hbar-logo.cf14c8a5.png";